import "./privacy.scss";

export default function Private() {
  return (
    <main className="privacy__pol">
      <h1>Privacy Policy</h1>
      <hr />
      <section className="policy">
        <ol>
          <li style={{ fontWeight: 700 }}>Introduction</li>
          <ol>
            <li>
              We are committed to safeguarding the privacy of our clients.
            </li>
            <li>
              This policy applies where we are acting as a data controller with
              respect to the personal data of our clients; in other words, where
              we determine the purposes and means of the processing of that
              personal data.
            </li>
            <li>
              We use cookies on our website. Insofar as those cookies are not
              strictly necessary for the provision of our website and services,
              we will ask you to consent to our use of cookies when you first
              visit our website.
            </li>
            <li>
              In this policy, “we”, “us” and “our” refer to Paul McFadden Wealth
              Ltd (also referred to as ‘PMW’). For more information about us,
              see Section 13.
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>Credit</li>
          <ol>
            <li>
              his document was created using a template from SEQ Legal{" "}
              <a href="https://seqlegal.com" target="_blank"></a>
              (https://seqlegal.com).
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>How we use your personal data</li>
          <ol>
            <li>In this Section 3 we have set out:</li>
            <ol>
              <li>
                the general categories of personal data that we may process;
              </li>
              <li>the purposes for which we may process personal data; and</li>
              <li>the legal bases of the processing.</li>
            </ol>
            <li>
              We may process data about your use of our website and services
              (“usage data“). The usage data may include: your IP address,
              geographical location, browser type and version, operating system,
              referral source, length of visit, page views and website
              navigation paths, as well as information about the timing,
              frequency and pattern of your service use. The source of the usage
              data is Google Analytics. This usage data may be processed for the
              purposes of analysing the use of the website and services. The
              legal basis for this processing is our legitimate interests,
              namely monitoring and improving our website and services.
            </li>
            <li>
              We may process your account data (“account data“). The account
              data may include your name and email address. The source of the
              account data is you. The account data may be processed for the
              purposes of operating our website, providing our services,
              ensuring the security of our website and services, maintaining
              back-ups of our databases and communicating with you. The legal
              basis for this processing is our legitimate interests, namely the
              proper administration of our website and business.
            </li>
            <li>
              We may process your information included in your personal profile
              on our website (“profile data“). The profile data may include
              [your name, address, telephone number, email address, profile
              pictures, gender, date of birth, relationship status, interests
              and hobbies, educational details and employment details.]The
              profile data may be processed for the purposes of enabling and
              monitoring your use of our website and services. The legal basis
              for this processing is consent OR our legitimate interests, namely
              the proper administration of our website and business OR the
              performance of a contract between you and us and/or taking steps,
              at you request, to enter into such a contract.
            </li>
            <li>
              {" "}
              We may process your personal data that are provided in the course
              of the use of our services (“service data“). The service data may
              include: your name; contact information; payment history;
              invoicing details; action reports; training vault access;
              testimonials; and background profile report. The source of the
              service data is you. The service data may be processed for the
              purposes of operating our website, providing our services,
              ensuring the security of our website and services, maintaining
              back-ups of our databases and communicating with you. The legal
              basis for this processing is consent OR our legitimate interests,
              namely the proper administration of our website and business OR
              the performance of a contract between you and us and/or taking
              steps, at your request, to enter into such a contract.
            </li>
            <li>
              We may process information that you post for publication on our
              website or through our services (“publication data“). The
              publication data may be processed for the purposes of enabling
              such publication and administering our website and services. The
              legal basis for this processing is consent OR our legitimate
              interests, namely the proper administration of our website and
              business OR the performance of a contract between you and us
              and/or taking steps, at your request, to enter into such a
              contract.
            </li>
            <li>
              We may process information contained in any enquiry you submit to
              us regarding goods and/or services (“enquiry data“). The enquiry
              data may be processed for the purposes of offering, marketing and
              selling relevant goods and/or services to you. The legal basis for
              this processing is consent.
            </li>
            <li>
              We may process information relating to our customer relationships,
              including customer contact information (“customer relationship
              data“).[ The customer relationship data may include your name,
              your employer, your job title or role, your contact details, and
              information contained in communications between us and you. The
              source of the customer relationship data is you. The customer
              relationship data may be processed for the purposes of managing
              our relationships with customers, communicating with customers,
              keeping records of those communications and promoting our products
              and services to customers. The legal basis for this processing is
              our legitimate interests, namely the proper management of our
              customer relationships.
            </li>
            <li>
              We may process information relating to transactions, including
              purchases of goods and services, that you enter into with us
              and/or through our website (“transaction data“). The transaction
              data may include your contact details, your card details and the
              transaction details. The transaction data may be processed for the
              purpose of supplying the purchased goods and services and keeping
              proper records of those transactions. The legal basis for this
              processing is the performance of a contract between you and us
              and/or taking steps, at your request, to enter into such a
              contract and our legitimate interests, namely the proper
              administration of our business and services.
            </li>
            <li>
              We may process information that you provide to us for the purpose
              of subscribing to our email notifications and/or newsletters
              (“notification data“). The notification data may be processed for
              the purposes of sending you the relevant notifications and/or
              newsletters. The legal basis for this processing is consent.
            </li>
            <li>
              We may process information contained in or relating to any
              communication that you send to us (“correspondence data“). The
              correspondence data may include the communication content and
              metadata associated with the communication. Our website will
              generate the metadata associated with communications made using
              the website contact forms. The correspondence data may be
              processed for the purposes of communicating with you and
              record-keeping. The legal basis for this processing is our
              legitimate interests, namely the proper administration of our
              website and business and communications with users.
            </li>
            <li>
              We may process any of your personal data identified in this policy
              where necessary for the establishment, exercise or defence of
              legal claims, whether in court proceedings or in an administrative
              or out-of-court procedure. The legal basis for this processing is
              our legitimate interests, namely the protection and assertion of
              our legal rights, your legal rights and the legal rights of
              others.
            </li>
            <li>
              We may process any of your personal data identified in this policy
              where necessary for the purposes of obtaining or maintaining
              insurance coverage, managing risks, or obtaining professional
              advice. The legal basis for this processing is our legitimate
              interests, namely the proper protection of our business against
              risks.
            </li>
            <li>
              In addition to the specific purposes for which we may process your
              personal data set out in this Section 3, we may also process any
              of your personal data where such processing is necessary for
              compliance with a legal obligation to which we are subject, or in
              order to protect your vital interests or the vital interests of
              another natural person.
            </li>
            <li>
              Please do not supply any other person’s personal data to us,
              unless we prompt you to do so.
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>
            Providing your personal data to others
          </li>
          <ol>
            <li>
              We may disclose your personal data to any member of our group of
              companies (this means our subsidiaries, our ultimate holding
              company and all its subsidiaries) insofar as reasonably necessary
              for the purposes, and on the legal bases, set out in this policy.
            </li>
            <li>
              We may disclose your personal data to our insurers and/or
              professional advisers insofar as reasonably necessary for the
              purposes of obtaining or maintaining insurance coverage, managing
              risks, obtaining professional advice, or the establishment,
              exercise or defence of legal claims, whether in court proceedings
              or in an administrative or out-of-court procedure.
            </li>
            <li>
              Financial transactions relating to our website and services may be
              handled by our payment services providers, Stripe, GoCardless,
              Xero, DonkeyBean, and APS Financial Ltd. We will share transaction
              data with our payment services providers only to the extent
              necessary for the purposes of processing your payments, refunding
              such payments and dealing with complaints and queries relating to
              such payments and refunds.
            </li>
            <li>
              We may disclose your enquiry data to one or more of those selected
              third party suppliers of goods and services identified on our
              website for the purpose of enabling them to contact you so that
              they can offer, market and sell to you relevant goods and/or
              services. Each such third party will act as a data controller in
              relation to the enquiry data that we supply to it; and upon
              contacting you, each such third party will supply to you a copy of
              its own privacy policy, which will govern that third party’s use
              of your personal data.
            </li>
            <li>
              In addition to the specific disclosures of personal data set out
              in this Section 4, we may disclose your personal data where such
              disclosure is necessary for compliance with a legal obligation to
              which we are subject, or in order to protect your vital interests
              or the vital interests of another natural person. We may also
              disclose your personal data where such disclosure is necessary for
              the establishment, exercise or defence of legal claims, whether in
              court proceedings or in an administrative or out-of-court
              procedure.
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>
            International transfers of your personal data
          </li>
          <ol>
            <li>
              In this Section 5, we provide information about the circumstances
              in which your personal data may be transferred to countries
              outside the European Economic Area (EEA).
            </li>
            <li>
              The hosting facilities for our website are situated in the United
              States of America. The European Commission has made an “adequacy
              decision” with respect to the data protection laws of each of
              these countries. Transfers to each of these countries will be
              protected by appropriate safeguards, namely the use of standard
              data protection clauses adopted or approved by the European
              Commission.
            </li>
            <li>
              You acknowledge that personal data that you submit for publication
              through our website or services may be available, via the
              internet, around the world. We cannot prevent the use (or misuse)
              of such personal data by others.
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>
            Retaining and deleting personal data{" "}
          </li>
          <ol>
            <li>
              This Section 6 sets out our data retention policies and procedure,
              which are designed to help ensure that we comply with our legal
              obligations in relation to the retention and deletion of personal
              data.
            </li>
            <li>
              Personal data that we process for any purpose or purposes shall
              not be kept for longer than is necessary for that purpose or those
              purposes.
            </li>
            <li>We will retain your personal data as follows:</li>
            <ol>
              <li>
                All personal data categories listed previously in this policy
                document will be retained for a minimum period of 1 year
                following the conclusion or termination of your membership with
                our services or programmes, and for a maximum period of 3 years
                following such a completion date.
              </li>
            </ol>
            <li>
              Notwithstanding the other provisions of this Section 6, we may
              retain your personal data where such retention is necessary for
              compliance with a legal obligation to which we are subject, or in
              order to protect your vital interests or the vital interests of
              another natural person.
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>Amendments</li>
          <ol>
            <li>
              We may update this policy from time to time by publishing a new
              version on our website.
            </li>
            <li>
              You should check this page occasionally to ensure you are happy
              with any changes to this policy.
            </li>
            <li>
              We may notify you of significant changes to this policy by email.
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>Your rights</li>
          <ol>
            <li>
              In this Section 8, we have summarised the rights that you have
              under data protection law. Some of the rights are complex, and not
              all of the details have been included in our summaries.
              Accordingly, you should read the relevant laws and guidance from
              the regulatory authorities for a full explanation of these rights.
            </li>
            <li>Your principal rights under data protection law are:</li>
            <ol>
              <li>the right to access;</li>
              <li>the right to rectification;</li>
              <li>the right to erasure;</li>
              <li>the right to restrict processing;</li>
              <li>the right to object to processing;</li>
              <li>the right to data portability;</li>
              <li>the right to complain to a supervisory authority; and</li>
              <li>the right to withdraw consent.</li>
            </ol>
            <li>
              You have the right to confirmation as to whether or not we process
              your personal data and, where we do, access to the personal data,
              together with certain additional information. That additional
              information includes details of the purposes of the processing,
              the categories of personal data concerned and the recipients of
              the personal data. Providing the rights and freedoms of others are
              not affected, we will supply to you a copy of your personal data.
              The first copy will be provided free of charge, but additional
              copies may be subject to a reasonable fee. You can access your
              personal data by contacting us through the following URL:
              www.paulmcfaddenwealth.com/contact
            </li>
            <li>
              You have the right to have any inaccurate personal data about you
              rectified and, taking into account the purposes of the processing,
              to have any incomplete personal data about you completed.
            </li>
            <li>
              In some circumstances you have the right to the erasure of your
              personal data without undue delay. Those circumstances include:
              the personal data are no longer necessary in relation to the
              purposes for which they were collected or otherwise processed; you
              withdraw consent to consent-based processing; you object to the
              processing under certain rules of applicable data protection law;
              the processing is for direct marketing purposes; and the personal
              data have been unlawfully processed. However, there are exclusions
              of the right to erasure. The general exclusions include where
              processing is necessary: for exercising the right of freedom of
              expression and information; for compliance with a legal
              obligation; or for the establishment, exercise or defence of legal
              claims.
            </li>
            <li>
              In some circumstances you have the right to restrict the
              processing of your personal data. Those circumstances are: you
              contest the accuracy of the personal data; processing is unlawful
              but you oppose erasure; we no longer need the personal data for
              the purposes of our processing, but you require personal data for
              the establishment, exercise or defence of legal claims; and you
              have objected to processing, pending the verification of that
              objection. Where processing has been restricted on this basis, we
              may continue to store your personal data. However, we will only
              otherwise process it: with your consent; for the establishment,
              exercise or defence of legal claims; for the protection of the
              rights of another natural or legal person; or for reasons of
              important public interest.
            </li>
            <li>
              You have the right to object to our processing of your personal
              data on grounds relating to your particular situation, but only to
              the extent that the legal basis for the processing is that the
              processing is necessary for: the performance of a task carried out
              in the public interest or in the exercise of any official
              authority vested in us; or the purposes of the legitimate
              interests pursued by us or by a third party. If you make such an
              objection, we will cease to process the personal information
              unless we can demonstrate compelling legitimate grounds for the
              processing which override your interests, rights and freedoms, or
              the processing is for the establishment, exercise or defence of
              legal claims.
            </li>
            <li>
              You have the right to object to our processing of your personal
              data for direct marketing purposes (including profiling for direct
              marketing purposes). If you make such an objection, we will cease
              to process your personal data for this purpose.
            </li>
            <li>
              You have the right to object to our processing of your personal
              data for scientific or historical research purposes or statistical
              purposes on grounds relating to your particular situation, unless
              the processing is necessary for the performance of a task carried
              out for reasons of public interest.
            </li>
            <li>
              To the extent that the legal basis for our processing of your
              personal data is:
            </li>
            <ol>
              <li>consent; or</li>
              <li>
                that the processing is necessary for the performance of a
                contract to which you are party or in order to take steps at
                your request prior to entering into a contract, and such
                processing is carried out by automated means, you have the right
                to receive your personal data from us in a structured, commonly
                used and machine-readable format. However, this right does not
                apply where it would adversely affect the rights and freedoms of
                others.
              </li>
            </ol>
            <li>
              If you consider that our processing of your personal information
              infringes data protection laws, you have a legal right to lodge a
              complaint with a supervisory authority responsible for data
              protection. You may do so in the EU member state of your habitual
              residence, your place of work or the place of the alleged
              infringement.
            </li>
            <li>
              To the extent that the legal basis for our processing of your
              personal information is consent, you have the right to withdraw
              that consent at any time. Withdrawal will not affect the
              lawfulness of processing before the withdrawal.
            </li>
            <li>
              You may exercise any of your rights in relation to your personal
              data by written notice to us.
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>About cookies</li>
          <ol>
            <li>
              A cookie is a file containing an identifier (a string of letters
              and numbers) that is sent by a web server to a web browser and is
              stored by the browser. The identifier is then sent back to the
              server each time the browser requests a page from the server.
            </li>
            <li>
              Cookies may be either “persistent” cookies or “session” cookies: a
              persistent cookie will be stored by a web browser and will remain
              valid until its set expiry date, unless deleted by the user before
              the expiry date; a session cookie, on the other hand, will expire
              at the end of the user session, when the web browser is closed.
            </li>
            <li>
              Cookies do not typically contain any information that personally
              identifies a user, but personal information that we store about
              you may be linked to the information stored in and obtained from
              cookies.
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>Cookies that we use</li>
          <ol>
            <li>We use cookies for the following purposes:</li>
            <ol>
              <li>
                authentication – we use cookies to identify you when you visit
                our website and as you navigate our website;
              </li>
              <li>
                status – we use cookies to help us to determine if you are
                logged into our website;
              </li>
              <li>
                personalisation – we use cookies to store information about your
                preferences and to personalise the website for you;
              </li>
              <li>
                security – we use cookies as an element of the security measures
                used to protect user accounts, including preventing fraudulent
                use of login credentials, and to protect our website and
                services generally;
              </li>
              <li>
                advertising – we use cookies to help us to display
                advertisements that will be relevant to you;
              </li>
              <li>
                analysis – we use cookies to help us to analyse the use and
                performance of our website and services;
              </li>
              <li>
                cookie consent – we use cookies to store your preferences in
                relation to the use of cookies more generally;
              </li>
            </ol>
          </ol>
          <li style={{ fontWeight: 700 }}>
            Cookies used by our service providers
          </li>
          <ol>
            <li>
              Our service providers use cookies and those cookies may be stored
              on your computer when you visit our website.
            </li>
            <li>
              We use Google Analytics to analyse the use of our website. Google
              Analytics gathers information about website use by means of
              cookies. The information gathered relating to our website is used
              to create reports about the use of our website. Google’s privacy
              policy is available at: https://www.google.com/policies/privacy/.
            </li>
            <li>
              We publish Google AdSense interest-based advertisements on our
              website. These are tailored by Google to reflect your interests.
              To determine your interests, Google will track your behaviour on
              our website and on other websites across the web using cookies.
              You can view, delete or add interest categories associated with
              your browser by visiting: https://adssettings.google.com. You can
              also opt out of the AdSense partner network cookie using those
              settings or using the Network Advertising Initiative’s
              multi-cookie opt-out mechanism at:
              http://optout.networkadvertising.org. However, these opt-out
              mechanisms themselves use cookies, and if you clear the cookies
              from your browser your opt-out will not be maintained. To ensure
              that an opt-out is maintained in respect of a particular browser,
              you may wish to consider using the Google browser plug-ins
              available at: https://support.google.com/ads/answer/7395996.
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>Managing cookies</li>
          <ol>
            <li>
              Most browsers allow you to refuse to accept cookies and to delete
              cookies. The methods for doing so vary from browser to browser,
              and from version to version. You can however obtain up-to-date
              information about blocking and deleting cookies via these links:
            </li>
            <ol>
              <li>
                <a
                  href="https://support.google.com/chrome/answer/95647?hl=en"
                  target="_blank"
                >
                  https://support.google.com/chrome/answer/95647?hl=en (Chrome);
                </a>
              </li>
              <li>
                <a
                  href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                  target="_blank"
                >
                  https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences
                  (Firefox);
                </a>
              </li>
              <li>
                <a
                  href="http://www.opera.com/help/tutorials/security/cookies/"
                  target="_blank"
                >
                  http://www.opera.com/help/tutorials/security/cookies/ (Opera);
                </a>
              </li>
              <li>
                <a href="https://support.apple.com/kb/PH21411" target="_blank">
                  https://support.apple.com/kb/PH21411 (Safari); and
                </a>
              </li>
              <li>
                <a
                  href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy"
                  target="_blank"
                >
                  https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy
                  (Edge).{" "}
                </a>
              </li>
            </ol>
            <li>
              Blocking all cookies will have a negative impact upon the
              usability of many websites.
            </li>
            <li>
              If you block cookies, you will not be able to use all the features
              on our website.
            </li>
          </ol>
          <li style={{ fontWeight: 700 }}>Our details</li>
          <ol>
            <li>
              This website is owned and operated by Paul McFadden Wealth Ltd.
            </li>
            <li>
              We are registered in Scotland under registration number SC588738,
              and our registered office is at Ground Floor, 7 Cambuslang Way,
              Cambuslang Investment Park, GLASGOW, G32 8ND.
            </li>
            <li>You can contact us:</li>
            <ol>
              <li>by post, to the postal address given above;</li>
              <li>using our website contact form;</li>
              <li>by telephone, on 0800 233 5596; or</li>
              <li>by email: support@paulmcfaddenwealth.com</li>
            </ol>
          </ol>
          <li style={{ fontWeight: 700 }}>Data Protection and Privacy</li>
          <ol>
            <li>
              We are committed to protecting your privacy and handling your
              personal data responsibly and in accordance with the UK General
              Data Protection Regulation (UK GDPR) and the Data Protection Act
              2018.
            </li>
            <li>
              By using our services, you agree that we may collect, store, and
              process your personal data as outlined in our Privacy Policy. This
              includes personal information you provide to us directly, as well
              as data we collect automatically when you interact with our
              website or services.
            </li>
            <li>
              We process your personal data where we have a lawful basis to do
              so. This may include processing necessary for the performance of a
              contract with you, compliance with our legal obligations, your
              consent, or our legitimate business interests.
            </li>
            <li>
              We act as the Data Controller for the personal data we collect.
              Where we engage third-party service providers (such as payment
              processors, hosting services, legal advisors), we ensure they meet
              appropriate data protection and security standards.
            </li>
            <li>
              We take appropriate technical and organisational measures to
              safeguard your personal data from unauthorised access, loss, or
              misuse.
            </li>
            <li>
              You have a number of rights under UK data protection law,
              including the right to access, correct, or delete your personal
              data, the right to object to or restrict certain types of
              processing, and the right to lodge a complaint with the
              Information Commissioner’s Office (ICO). Further details are
              provided in our Privacy Policy.
            </li>
          </ol>

          <li style={{ fontWeight: 700 }}>Data protection officer</li>
          <ol>
            <li>Our data protection officer’s contact details are:</li>
            <li>
              Data Protection Officer <br />
              Paul McFadden Wealth Ltd <br />
              Ground Floor 7 Cambuslang Way <br />
              Cambuslang Investment Park, <br />
              GLASGOW <br />
              G32 8ND <br />
              tel – 0800 233 5596 <br />
              email – support@teampmw.com.
            </li>
          </ol>
        </ol>
      </section>
    </main>
  );
}
